"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var urlUtils_1 = require("../../utils/urlUtils");
var Url = require("url-parse");
function getSiteMembersApiUrl(origin) {
    var url = new Url(origin);
    var baseApiUrl;
    if (
    // dashboard
    url.hostname === "www.wix.com" /* WIX */ ||
        // EditorX
        url.hostname.endsWith("editorx.com" /* EDITORX */) ||
        // in editor
        url.hostname === "groups.wixapps.net" /* GROUPS */ ||
        url.hostname.endsWith("dev.wix-code.com" /* DEV_WIX_CODE */)) {
        baseApiUrl = '_api/wix-sm-webapp';
    }
    else {
        baseApiUrl = 'api/wix-sm';
    }
    return url.origin + "/" + baseApiUrl + "/v1/members";
}
function getMembersAreaApiUrl(origin) {
    var url = new Url(origin);
    return url.origin + "/_api/members-follow-server/v1/";
}
/**
 * Members Api - client for groups site members api
 * https://bo.wix.com/wix-docs/rest/business-apis#social-groups.social-group-membership
 *
 */
var MembersApi = /** @class */ (function () {
    /**
     * @param {string} token - jwt for site instance
     * (see [more](https://github.com/wix-private/platformization-guidelines/blob/master/guides/instance.md#instance))
     * @param {string} apiUrl
     */
    function MembersApi(token, apiUrl) {
        this.token = token;
        this.axios = axios_1.default.create({
            baseURL: apiUrl,
            headers: {
                Authorization: token,
            },
        });
        //https://github.com/wix-private/crm/blob/f69131107079190ba2d7a342f2399f401f9f09f9/wix-site-members/wix-sm-platform-api/members-api/src/main/proto/MembersService.proto#L16
        var baseURL = getSiteMembersApiUrl(apiUrl);
        this.siteMembersClient = axios_1.default.create({
            baseURL: baseURL,
            headers: {
                Authorization: token,
            },
        });
        var membersAreaBaseURL = getMembersAreaApiUrl(apiUrl);
        this.membersAreaClient = axios_1.default.create({
            baseURL: membersAreaBaseURL,
            headers: {
                Authorization: token,
            },
        });
    }
    MembersApi.prototype.getUrl = function (groupId) {
        return "/v1/groups/" + groupId + "/members";
    };
    MembersApi.prototype.listGroupMembers = function (groupId, params) {
        return this.axios.get(this.getUrl(groupId), {
            params: params,
        });
    };
    MembersApi.prototype.listAllMembers = function (groupId, params) {
        return this.axios.get(this.getUrl(groupId) + "/all", {
            params: params,
        });
    };
    MembersApi.prototype.queryAllMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post(this.getUrl(groupId) + "/all", { query: query });
    };
    MembersApi.prototype.querySiteMembers = function (query) {
        return this.siteMembersClient.post('/query', {
            query: JSON.stringify(query),
        });
    };
    MembersApi.prototype.queryNonGroupMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post(this.getUrl(groupId) + "/non_group", { query: query });
    };
    MembersApi.prototype.queryGroupMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post("" + this.getUrl(groupId), { query: query });
    };
    MembersApi.prototype.listPendingMembers = function (groupId, limit, cursorToken) {
        var q = limit || cursorToken ? "?" + urlUtils_1.buildQuery({ limit: limit, cursorToken: cursorToken }) : '';
        return this.axios.get(this.getUrl(groupId) + "/pending" + q);
    };
    MembersApi.prototype.followMember = function (siteMemberId) {
        return this.membersAreaClient.post("follow/" + siteMemberId);
    };
    MembersApi.prototype.unfollowMember = function (siteMemberId) {
        return this.membersAreaClient.post("unfollow/" + siteMemberId);
    };
    /**
     *
     * @param {string} siteMemberId
     * @return {Promise<AxiosResponse<ListFollowingsResponse>>}
     */
    MembersApi.prototype.getFollowingMembers = function (siteMemberId) {
        //TODO: over 9000 followings?
        return this.membersAreaClient.get("followings/" + siteMemberId);
    };
    MembersApi.prototype.approveGroupMembershipRequests = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/approve", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.rejectGroupMembershipRequests = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/reject", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.joinGroup = function (groupId, membershipQuestionsAnswers) {
        return this.axios.post(this.getUrl(groupId) + "/me", {
            membership_question_answers: membershipQuestionsAnswers,
        });
    };
    MembersApi.prototype.withdrawRequestToJoin = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/request");
    };
    MembersApi.prototype.submitRequestToJoin = function (groupId, membershipQuestionsAnswers) {
        return this.axios.post(this.getUrl(groupId) + "/request", {
            membership_question_answers: membershipQuestionsAnswers,
        });
    };
    MembersApi.prototype.leaveGroup = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/me");
    };
    MembersApi.prototype.getGroupMember = function (groupId, siteMemberId) {
        return this.axios.get(this.getUrl(groupId) + "/member/" + siteMemberId);
    };
    MembersApi.prototype.addToGroup = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/add", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.addAllNonGroupMembersToGroup = function (groupId, excludedSiteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/non_group/add", {
            excludedSiteMemberIds: excludedSiteMemberIds,
        });
    };
    MembersApi.prototype.removeFromGroup = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/remove", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.setMemberRole = function (groupId, siteMemberId, role) {
        return this.axios.post(this.getUrl(groupId) + "/" + siteMemberId + "/role", {
            role: role,
        });
    };
    MembersApi.prototype.getCurrentSiteMember = function () {
        //TODO: is there a SDK method?
        return this.siteMembersClient.get('/current', {
            headers: {
                Authorization: this.token,
            },
        });
    };
    MembersApi.prototype.updateSiteMember = function (id, member, paths) {
        return this.siteMembersClient.patch("/" + id, {
            member: member,
            fieldMask: {
                paths: paths,
            },
        }, {
            headers: {
                Authorization: this.token,
            },
        });
    };
    MembersApi.prototype.updateSiteMemberPrivacy = function (id, profilePrivacyStatus) {
        return this.updateSiteMember(id, { profilePrivacyStatus: profilePrivacyStatus }, [
            'privacyStatus',
        ]);
    };
    MembersApi.prototype.countNewMembers = function (groupId, query) {
        return this.axios.post(this.getUrl(groupId) + "/count", { query: query });
    };
    MembersApi.prototype.countNonGroupMembers = function (groupId) {
        return this.axios.get(this.getUrl(groupId) + "/non_group/count");
    };
    MembersApi.prototype.getMembershipQuestions = function (groupId) {
        return this.axios.get("v1/groups/" + groupId + "/membership-questions");
    };
    MembersApi.prototype.saveMembershipQuestions = function (_a) {
        var groupId = _a.groupId, questions = _a.questions;
        return this.axios.post("v1/groups/" + groupId + "/membership-questions", {
            questions: questions,
        });
    };
    MembersApi.prototype.listMembershipQuestionAnswers = function (groupId, siteMemberIds, itemsFilter) {
        var req = {
            itemsFilter: itemsFilter,
            groupId: groupId,
            siteMemberIds: siteMemberIds,
        };
        return this.axios.post("v1/groups/" + groupId + "/membership-answers", req);
    };
    return MembersApi;
}());
exports.MembersApi = MembersApi;
//# sourceMappingURL=MembersApi.js.map